(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autoplay-video-section"] && !Shopify.designMode) return;
  try {
    
(() => {
  const btns = document.querySelectorAll('.onhow-content-btn.lg-liquid-glass');
  btns.forEach(btn => {
    function move(e){
      const r = btn.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%';
      const y = ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%';
      btn.style.setProperty('--lg-spot-x', x);
      btn.style.setProperty('--lg-spot-y', y);
      const ang = ((parseFloat(x) || 50) / 100) * 360;
      btn.style.setProperty('--lg-ring-ang', ang + 'deg');
    }
    btn.addEventListener('pointermove', move, {passive:true});
    btn.addEventListener('pointerleave', ()=>{
      btn.style.removeProperty('--lg-spot-x');
      btn.style.removeProperty('--lg-spot-y');
    }, {passive:true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
